(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["launch-popup"]) return;
  try {
    
  if (!customElements.get('astrea-launch-popup')) {
    customElements.define('astrea-launch-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        const now = Date.now();
        const start = Date.parse('2026-09-30T07:00:00Z');
        const end = Date.parse('2026-10-08T07:00:00Z');
        const preview = new URLSearchParams(location.search).get('launch_preview') === '1' || this.dataset.editor === 'true';
        if (now >= end && !preview) return;
        const active = now >= start && now < end;
        this.dialog.dataset.sale = active ? 'active' : 'upcoming';
        this.querySelectorAll('[data-active]').forEach(el => el.hidden = !active);
        this.querySelectorAll('[data-upcoming]').forEach(el => el.hidden = active);
        this.key = 'astrea-launch-2026-' + (active ? 'active' : 'upcoming');
        this.querySelectorAll('.astrea-popup__close,.astrea-popup__continue').forEach(el => el.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', e => {
          if (e.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => { try { localStorage.setItem(this.key, 'seen'); } catch {} });
        this.querySelector('form').addEventListener('submit', () => { try { localStorage.setItem(this.key, 'seen'); } catch {} });
        let seen = false;
        try { seen = localStorage.getItem(this.key) === 'seen'; } catch {}
        if (!seen || preview) this.timer = setTimeout(() => {
          if (this.isConnected && !document.querySelector('dialog[open]')) this.dialog.showModal();
        }, preview ? 100 : 900);
      }
      disconnectedCallback() { clearTimeout(this.timer); if (this.dialog?.open) this.dialog.close(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch-sale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('astrea-launch-sale')) {
    customElements.define('astrea-launch-sale', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.onToggle = () => {
          const paused = this.toggleAttribute('data-paused');
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.textContent = paused ? this.dataset.play : this.dataset.pause;
        };
        this.button.addEventListener('click', this.onToggle);
        this.refresh();
        this.resizeObserver = new ResizeObserver(() => this.updateOffset());
        this.resizeObserver.observe(this);
        this.updateOffset();
        this.timer = setInterval(() => this.refresh(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.resizeObserver.disconnect();
        document.body.style.removeProperty('--astrea-sale-height');
        this.button.removeEventListener('click', this.onToggle);
      }
      updateOffset() {
        document.body.style.setProperty('--astrea-sale-height', this.hidden ? '0px' : `${this.getBoundingClientRect().height}px`);
      }
      refresh() {
        const now = Date.now();
        const start = Date.parse('2026-09-30T00:00:00-07:00');
        const end = Date.parse('2026-10-08T00:00:00-07:00');
        const expired = now >= end;
        if (this.hidden !== expired) {
          this.hidden = expired;
          this.updateOffset();
        }
        const text = now < start ? this.dataset.before : this.dataset.active;
        if (text !== this.lastText) {
          this.querySelector('.astrea-sale-accessible').textContent = text;
          this.querySelectorAll('.astrea-sale-copy > span').forEach(node => { node.textContent = text; });
          this.lastText = text;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
